import { AlternativesCTASection, CTASectionProps } from "@components/alternatives/AlternativesCTASection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import ProblemSectionCard, { ProblemSection } from "@components/solution/problemSectionCard";
import { BlueCardCTASection, GreyCardCTASection } from "@components/solution/solutionCTASection";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "GALLABOX FOR ENTERPRISES",
    title: "The best WhatsApp solution for enterprises",
    description: "Reach hundreds of thousands of customers (no code required), boost engagement rates and reduce costs at every level",
    primaryButtonText: "Start free trial",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/hero-image.png",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "AI chatbots and custom workflows",
    subtitle2: "Gallabox helps enterprises streamline customer interactions and tackle support efficiently",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/customer-workflows.png",
    featureInfoList: [
        "AI chatbots for customer queries and service tickets",
        "Custom workflows to help humanize interactions",
        "Effective agent handoff ensures the right agent takes over customer conversations when needed.",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Shared team inboxes",
    subtitle2: "Use Gallabox’s Shared Team Inbox to make sure your teams are always on the same page",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/shared-team-inbox.png",
    featureInfoList: [
        "Handle large volumes of queries and tickets",
        "Single dashboard to display conversations across the organization in one place",
        "Easy agent handoffs and interventions",
    ],
};
const featureInfo3: FeatureInfo = {
    mainTitle: "Personalized marketing campaigns",
    subtitle2: "Increase conversions with personalized drip campaigns",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/campaign.png",
    featureInfoList: ["Tailor conversations based on prospect responses", "Create trigger-based flows to drive better engagement", "Close deals faster with personalized offers"],
};
const featureInfo4: FeatureInfo = {
    mainTitle: "Enterprise-grade sales agents",
    subtitle2: "Deploy round-the-clock bots that serve as sales agents for your organization",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/enterprise-grade.png",
    featureInfoList: ["Nurture leads better", "Automated and timely follow-ups", "Instant trigger-based database updates"],
};

const featureInfo5: FeatureInfo = {
    mainTitle: "Integration made effortless",
    subtitle2: "Enterprise systems need a unified source of truth across all their applications",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/integration.png",
    featureInfoList: [
        "Sync your WhatsApp Business with your CRM, ERP and 30+ other tools",
        "Stay on top of conversations, and manage your pipeline hassle-free",
        "Reduce manual logging efforts by up to 90%",
    ],
};
const ProblemSectionData: ProblemSection = {
    maintitle: "Tackle customer experience at scale with Gallabox",
    problemSectionCard: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/campaign.svg",
            title: "Dealing with dips in marketing campaigns' ROI",
            description:
                "We are in the age of personalized marketing, and the age-old cold email blast just doesn’t cut it anymore. Enterprises require personalized communication at all costs.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/pipleline.svg",
            title: "Challenges in building high-converting flows",
            description:
                "Enterprise companies face workflow challenges due to complex buyer journeys, siloed data, and misaligned teams, making personalization and optimization difficult.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
            title: "Disconnected tech stack killing productivity",
            description:
                "Integrating your ERP, CRM, payments, and entire tech stack can be challenging for large organizations. Managing a unified data source increases operational lag.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/data-analysis.svg",
            title: "Data privacy and security concerns",
            description:
                "Enterprises today need to prioritize data privacy and security — especially when it comes to navigating complex customer journeys. Solving for this is a big challenge",
        },
    ],
};

const enterpriseProductData: Array<Product> = [
    {
        title: "Manage customer conversations at scale",
        description: "Custom chatbots that can handle customer interactions 24x7, saving you up to 40% on staffing costs.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/bot.svg",
        externalLink: "",
    },
    {
        title: "Handle increased communication with ease",
        description: "Efficiently tackle high-volume inquiries and sudden surges in customer queries using automated responses",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
        externalLink: "",
    },
    {
        title: "Push personalized outreach campaigns at scale",
        description: "Send tailored drip campaigns based on customer preferences, purchase history, and behavioral triggers.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/personalisation.svg",
        externalLink: "",
    },
    {
        title: "Automate prospect management and support",
        description: "Chat workflows help enterprise teams qualify leads, answer FAQs, and facilitate agent intervention instantly",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/personalisation.svg",
        externalLink: "",
    },
    {
        title: "Integrate seamlessly with enterprise systems",
        description: "Maintain a single source of truth by integrating your WhatsApp Business with your entire tech stack",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
        externalLink: "",
    },
    {
        title: "Keep conversations going using rich media",
        description: "Deploy images, videos, voice notes, and interactive buttons to your advantage with Rich Media",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/profile-image.svg",
        externalLink: "",
    },
    {
        title: "Implement enterprise-ready security standards",
        description: "Maintain enterprise-grade security with end-to-end encryption and ensure data privacy.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/secure-database.svg",
        externalLink: "",
    },
    {
        title: "Enable 24/7 agent availability",
        description: "Push round-the-clock support and engagement across multiple time zones without increasing operational costs.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/customer-support.png",
        externalLink: "",
    },
];

const greyCardCTAContent: CTASectionProps = {
    content: "Qatar Insurance Company increased their lead inflow by 200% with Gallabox",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/qic.png",
    imgAlt: "wa-gallabox",
    btnText: "Start a free trial today",
};

const blueCardCTAContent: CTASectionProps = {
    content: "Unlock enterprise growth with WhatsApp automation",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/sales-cta.png",
    imgAlt: "wa-gallabox",
    btnText: "Start free trial",
};

const sales: React.FC = () => {
    return (
        <NewLayout
            title={"WhatsApp Solutions for Enterprise Teams | Gallabox"}
            description={"Streamline engagement with Gallabox’s WhatsApp Business Tool for Enterprise—automate processes, scale conversations, and grow securely."}
            canonical="https://gallabox.com/solutions/enterprise"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/solution/enterprises/solution-enterprises-og.png" }}
            schema={{
                heroOrOgImageAlt: "solutions-enterprises-image",
                heroOrOgImageDescription: "The best WhatsApp solution for enterprises",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/solution/enterprises/hero-image.png",
                softwareFeatureName: "enterprises",
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">Trusted by 10,000+ businesses</h3>
                <ClientLogos />
            </section>

            <ProblemSectionCard problemSection={ProblemSectionData} />
            <section className="mx-5">
                <BlueCardCTASection ctaContent={blueCardCTAContent} />
            </section>

            <h5 className={`${container_classname} md:text-7xl text-5xl mt-20`} style={{ fontFamily: "Degular Display" }}>
                Why enterprises trust Gallabox
            </h5>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />
            <FeatureInfoCard {...featureInfo5} />

            <div className="mx-5">
                <AlternativesCTASection
                    ctaContent={{
                        content: "Add WhatsApp automation to your tech stack",
                        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/interakt/wa-gallabox.png",
                        imgAlt: "sales-automations",
                        btnText: " Start  a free trial today",
                    }}
                />
            </div>

            <ProductSection productCardData={enterpriseProductData} title="How Gallabox transforms enterprise teams" />
            <div className={`${container_classname} my-20`}>
                <h5 className="text-6xl mb-10">Customer story</h5>
            </div>
            <section className="mx-5">
                <GreyCardCTASection ctaContent={greyCardCTAContent} />
            </section>

            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Turn connections into conversions" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default sales;
